module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Password"
  }, [_c('div', {
    staticClass: "Password__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: [_vm.defaultClass],
    attrs: {
      "type": "password",
      "name": _vm.name,
      "id": _vm.id,
      "placeholder": _vm.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": _vm._s(_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.badge) ? _c('div', {
    staticClass: "Password__badge",
    class: [_vm.isSecure ? _vm.successClass : '', !_vm.isSecure && _vm.isActive ? _vm.errorClass : '']
  }, [_vm._v("\n      " + _vm._s(_vm.passwordCount) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: [_vm.strengthMeterClass]
  }, [_c('div', {
    class: [_vm.strengthMeterFillClass],
    attrs: {
      "data-score": _vm.passwordStrength
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-82292b7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordStrengthMeter.vue
// module id = 9
// module chunks = 2